import { Box } from '@mui/material';
import SPForm from '../../../components/SellerProfile/Form/SPForm';
import './EditMySettings.scss';
import settingsForm from '../../../components/SellerProfile/Form/json/mySettingsFormFields.json';
import SPFormButton from '../../../components/SellerProfile/Form/SPFormButton';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { doFormErrorMsgs, isEmpty } from '../APIs/Helpers';
import { setShowSuccessPopUp } from '../../../redux/slices/sellerProfileSlice';
import { getUserProfileStart, requestAccessStart, UpdateUserProfileStart, resetSubmitSuccess, requestSuccess } from '../../../redux/slices/mySettingSlice';
import { fetchCompanyProfileStart } from '../../../redux/slices/sellerProfileSlice';

function EditAdminUserSettings() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({});
  const [requestLinks, setRequestLinks] = useState({});
  const { seller_id, user_id, formLoading, compProfile,spPageText,formUpdates } = useSelector((state: any) => state.sellerProfile);
  const { mySettingUsers, success, loading, submitSuccess } = useSelector((state: any) => state.mySetting);

  const requestAccess = (access) => {
    const requestAccessAPIval = {
      additional_access_id: access?.id
    };
    dispatch(requestAccessStart({ access: requestAccessAPIval }));
    try {
      if (success) {
        setRequestLinks({ ...requestLinks, [access.id]: `Requested` });
        dispatch(requestSuccess(false))
      } else {
        console.log('error requesting access');
        setRequestLinks({
          ...requestLinks,
          [access.id]: t('sellerProfile.dashboard.errorRequestAccess')
        });
      }
    }
    catch (error: any) {
      doFormErrorMsgs(error, dispatch,spPageText);
    };
  };

  useEffect(() => {
    if (Object.keys(mySettingUsers).length > 0) {
      //Disable notifications and display can't opt out msg when applicable
      if (mySettingUsers?.role_id === 'USR001') {
        settingsForm['notifications']['showNote'] = true;
        Object.keys(settingsForm['notifications']['options']).forEach(
          (key) => {
            settingsForm['notifications']['options'][key]['disabled'] = true;
          }
        );
        Object.keys(settingsForm['addtional_access_id']['options']).forEach(
          (key) => {
            settingsForm['addtional_access_id']['options'][key]['disabled'] =
              true;
          }
        );
      } else {
        settingsForm['notifications']['showNote'] = false;
      }
      //Show hide Requested/Request Access next to Access (Jira/Sandbox) where applicable
      const accessIds = ['ADA001', 'ADA002'];
      const tempRequestLinks = {};
      accessIds.forEach((id) => {
        if (
          mySettingUsers?.addtional_access_request?.includes(id) &&
          !mySettingUsers?.addtional_access_id?.includes(id)
        ) {
          //NOTE TYPO IN API
          settingsForm['addtional_access_id']['options'][id]['notes'] =
            t('sellerProfile.dashboard.requested');
        } else if (
          !mySettingUsers?.addtional_access_id?.includes(id) //NOTE TYPO IN API
        ) {
          settingsForm['addtional_access_id']['options'][id][
            'clickableNotes'
          ] = true;
          tempRequestLinks[
            id
          ] = `<a class='accessRequest'>${t('sellerProfile.dashboard.requestAccess')}</a>`;
        }
      });
      setRequestLinks(tempRequestLinks);
      setFormData(mySettingUsers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mySettingUsers]);


  const getUserProfile = () => {
    try {
      dispatch(getUserProfileStart());
    }
    catch (error) {
      doFormErrorMsgs(error, dispatch,spPageText);
    };
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (isEmpty(compProfile) && seller_id) {
      dispatch(fetchCompanyProfileStart({ seller_id, language: i18n.language }));
      try {
        getUserProfile();
      }
      catch (error) {
        console.log('Error getting company profile in User Settings', error);
      };
    } else {
      seller_id && getUserProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seller_id]);

  const submitFormFields = async (formName) => {
    try {
      dispatch(UpdateUserProfileStart({ formUpdates: formUpdates }))
      // getUserProfile();
      // dispatch(fecthAllUsers({ seller_id, user_id }));
    }
    catch (error) {
      displayErrorByType(mySettingUsers);
      dispatch(setShowSuccessPopUp({
        message: t('sellerProfile.dashboard.errorGeneral'),
        successType: 'error'
      }));
      console.log('Error updating user settings', error);
    };
  };

  useEffect(() => {
    if (submitSuccess) {
      const successMsg = t('sellerProfile.dashboard.changesSaved');
      dispatch(setShowSuccessPopUp(successMsg));
      dispatch(resetSubmitSuccess(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitSuccess]);

  return !isEmpty(formData) ? (
    <Box>
      <form>
        <SPForm
          cols="single"
          compName="mySettings"
          formFields={settingsForm}
          formName="editMySettings"
          user_id={user_id}
          formData={formData}
          key="mySettings"
          showLoading={loading}
          handleClickableNote={requestAccess}
          clickableNoteContent={requestLinks}
        />
        <div className="mySettings">
          {!formLoading && (
            <SPFormButton
              label={t('sellerProfile.dashboard.saveChanges')}
              compName="updateUserSettings"
              formName="editMySettings"
              handleClick={() => submitFormFields('editMySettings')}
              showLoading={loading}
            />
          )}
        </div>
      </form>
    </Box>
  ) : (
    <></>
  );
}

export default EditAdminUserSettings;
function displayErrorByType(mySettingUsers: any) {
  throw new Error('Function not implemented.');
}
